(function () {
	const track = document.querySelector('.marquee-track');
	const container = document.querySelector('.testimonial-slider');

	if (!track || !container || typeof gsap === 'undefined') {
		return;
	}

	const slides = [...track.children];
	const minItems = 4;

	if (slides.length < minItems) {
		return;
	}

	for (let i = 0; i < 2; i++) {
		slides.forEach((slide) => {
			track.appendChild(slide.cloneNode(true));
		});
	}

	let x = 0;
	let speed = 0.5;
	let isDragging = false;
	let lastX;

	function animate() {
		if (!isDragging) {
			x -= speed;
		}
		if (Math.abs(x) >= track.scrollWidth / 2) {
			x = 0;
		}
		gsap.set(track, { x });
		requestAnimationFrame(animate);
	}

	animate();

	container.addEventListener('mouseenter', () => {
		speed = 0;
	});
	container.addEventListener('mouseleave', () => {
		if (!isDragging) {
			speed = 0.5;
		}
	});

	container.addEventListener('mousedown', (e) => {
		isDragging = true;
		lastX = e.clientX;
	});
	window.addEventListener('mouseup', () => {
		isDragging = false;
		speed = 0.5;
	});
	window.addEventListener('mousemove', (e) => {
		if (!isDragging) {
			return;
		}
		x += e.clientX - lastX;
		lastX = e.clientX;
	});

	container.addEventListener('touchstart', (e) => {
		isDragging = true;
		lastX = e.touches[0].clientX;
	});
	container.addEventListener('touchend', () => {
		isDragging = false;
		speed = 0.5;
	});
	container.addEventListener('touchmove', (e) => {
		if (!isDragging) {
			return;
		}
		const current = e.touches[0].clientX;
		x += current - lastX;
		lastX = current;
	});
})();
